import mapKnownValues from "../../utils/mapKnownValues";

export type LaunchDetailsAPIResponse = {
  launchDate: string;
  launchDetailsId: number;
  launchEmail: string;
  launchSubject: string;
  manifestSendsEmail: true;
  participantFileName: string;
  tenantId: number;
};

export default class LaunchDetails {
  launchDate: Date | null = null;
  launchDetailsId = -1;
  launchEmail = "";
  launchEmailSubject = "";
  manifestSendEmail = false; // By default, Manifest will not send email for employer
  participantFileName: string | undefined = ""; // This is the participant data
  tenantId = -1;
  _originalData = "";

  constructor(params: Partial<LaunchDetails> = {}) {
    mapKnownValues(this, { ...params });
    if (!params._originalData) {
      this._originalData = JSON.stringify({
        ...this,
        _originalData: undefined,
      });
    }
  }

  get hasChanged() {
    return (
      JSON.stringify({
        ...this,
        _originalData: undefined,
      }) !== this._originalData
    );
  }

  get isPrelaunched() {
    return this.launchDate ? new Date(this.launchDate).getTime() > new Date().getTime() : true;
  }

  get isCompleted() {
    return this.participantFileName && this.launchDate;
  }

  static fromAPI(response: LaunchDetailsAPIResponse) {
    return new LaunchDetails({
      ...response,
      launchDate: response.launchDate ? new Date(response.launchDate) : null,
    });
  }

  toJSONForAPI() {
    return JSON.stringify({
      ...this,
      _originalData: undefined,
      launchDate: this.launchDate,
      participantFileName: this.participantFileName || undefined,
    });
  }
}

export const createEmailTemplate = ({ companyName }: { companyName?: string }) => {
  const userCompanyName = companyName || "[YOUR COMPANY]";
  return {
    subject: `Introducing Manifest for ${userCompanyName} 💰`,
    body: `Did you know the average American employee leaves behind 2.8 retirement accounts when changing jobs?
    
${userCompanyName} is excited to help you consolidate your old accounts by introducing your newest employee benefit: Manifest, the only plan-to-plan 401(k) rollover solution. 

🌟 Why Manifest?
   💸 Consolidate old retirement accounts into your plan at ${userCompanyName} effortlessly.
   🚀 Transfer in just 10 minutes (not 60 days).
   🙌 Average savings growth of over $8,800!
    
Don't let your hard-earned retirement funds go to waste. Start your journey with Manifest today and supercharge your retirement outcomes!   

[Customized link - coming soon]  

Disclaimer: For illustrative purposes only. This is not a prediction or guarantee of future performance and is based on an estimation of your balances, not your actual balance.`,
  };
};
